import React, { useState } from 'react';
import {
  PdfViewerContext,
  PdfViewerOptions,
} from './pdf-viewer-context';
import { PdfViewerModal } from '../components/ui/pdf-viewer-modal';
import { resolvePdfUrl } from '../../infrastructure/utils/media-url.helper';

export const PdfViewerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<PdfViewerOptions | null>(null);

  const openPdf = (newOptions: PdfViewerOptions) => {
    setOptions({
      ...newOptions,
      url: resolvePdfUrl(newOptions.url),
    });
    setIsOpen(true);
  };

  const closePdf = () => {
    setIsOpen(false);
  };

  return (
    <PdfViewerContext.Provider value={{ isOpen, options, openPdf, closePdf }}>
      {children}
      <PdfViewerModal isOpen={isOpen} options={options} onClose={closePdf} />
    </PdfViewerContext.Provider>
  );
};
